import type { ReactNode } from 'react'

import { Placeholder } from '@/src/elements/placeholder'

export const TagsButtonPlaceholders = (): ReactNode => (
  <>
    {['w-32', 'w-24', 'w-24', 'w-32', 'w-40', 'w-40', 'w-32', 'w-40', 'w-24', 'w-40', 'w-24', 'w-32'].map(
      (className, index) => (
        // oxlint-disable-next-line react/no-array-index-key
        <Placeholder key={index} className={`h-12 rounded-full ${className}`} />
      ),
    )}
  </>
)
